import { useState, useRef } from 'react';
import CreditsBalance from '../components/CreditsBalance';
import ActionCards from '../components/ActionCards';
import CreditSlider from '../components/CreditSlider';
import BillingHistory from '../components/BillingHistory';
import PageTitle from '../components/PageTitle';

const MySubscriptionTab = () => {
    const sliderRef = useRef(null);
    const [packListings, setPackListings] = useState(null);

    const handleSelectPack = (listings) => {
        setPackListings(listings);
        // Scroll to slider
        sliderRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    return (
        <>
            <PageTitle title="Buy Credits" badge="One-time purchase. No subscriptions. Credits never expire." />

            <div className="flex items-stretch gap-4 mb-8">
                <CreditsBalance />
                <ActionCards onSelectPack={handleSelectPack} />
            </div>

            <div className="mb-8" ref={sliderRef}>
                <CreditSlider presetListings={packListings} onPresetConsumed={() => setPackListings(null)} />
            </div>

            <BillingHistory />
        </>
    );
};

export default MySubscriptionTab;
